import cn from 'classnames';
import { HTMLAttributes } from 'react';
import { CardFooter } from '@/shared/ui/core';
import styles from './registration-card.module.scss'


export function RegistrationCardFooter ({ className, ...props }: HTMLAttributes<HTMLDivElement>) {
    return (
        <CardFooter
            className={ cn(styles.footer, className) }
            data-template="auth-card-footer"
            { ...props }
        />
    );
}
